export default "__VITE_ASSET__B8yZE2mN__"